import React from 'react';
import './home.scss';
import { getBanner, addApply } from '@/api/user';
import { Carousel, Checkbox, Modal, Button, Input  } from 'antd';

class Home extends React.Component{
	constructor (props) {
		super(props);
		this.carouselRef = null;
		this.setCarouselRef = el => {
			this.carouselRef = el
		};
		this.state={
			imgCurrent: 0,
			sale: [
				{
					icon: 'miaozhun',
					title: '精准营销',
					text: [
						'精准锁定泛行业消费人群',
						'整合高性价比资源',
						'让您的企业营销省时、省力'
					]
				},
				{
					icon: 'pingpai',
					title: '品牌营销',
					text: [
						'提供实时行业，人群分析',
						'品牌客户全案整合',
						'精品资源助力品牌营销'
					]
				},
				{
					icon: 'dingzhi',
					title: '行业营销',
					text: [
						'金融、游戏、旅游行业定制',
						'合理开展企业精品活动',
						'为您的营销活动推波助澜'
					]
				}
			],
			locals: [
				{
					icon: 'team',
					title: '优质运营',
					text: [
						'核心运营团队',
						'均有四年以上运营经验',
						'能快速响应服务'
					]
				},
				{
					icon: 'fuwu',
					title: '服务保障',
					text: [
						'从公司成立至今',
						'无任何客户投诉和负面新闻',
						'服务保障值得信赖'
					]
				},
				{
					icon: 'yizhan',
					title: '一站采买',
					text: [
						'全媒体覆盖',
						'一站式采买',
						'全案整合'
					]
				},
				{
					icon: 'fenlei',
					title: '行业专项',
					text: [
						'按行业细分专项服务',
						'涵盖金融、电商、游戏等',
						'深钻行业趋势与数据'
					]
				}
			],
			forms: [
				{
					errorType: false,
					errorMessage: '',
					testError: '企业名称不符合要求'
				},
				{
					errorType: false,
					errorMessage: '',
					testError: '姓名不符合要求'
				},
				{
					errorType: false,
					errorMessage: '',
					testError: '手机号码格式不正确'
				},
				{
					errorType: false,
					errorMessage: '',
					testError: '邮箱格式不正确'
				}
			],
			isChecked: false,
			visible: false,
			imgList: [],
			form: {
				name: '',
				mobile: '',
				email: '',
				company_name: ''
			},
			modalContnet: '我们的广告顾问将在两个工作日内与您电话联系，请您保持电话畅通',
			errMessage: '系统错误',
			modalTitle: '预约成功',
			btnText: '我知道了',
			error: false,
            company_name: '',
            name: '',
            mobile: '',
            email: '',
            warn1: '',
            warn2: '',
            warn3: '',
            warn4: '',
            showInput: false,
            pickIcon: 0
		}
	}
	handleOk () {
		this.setState({
			visible: false
		})
	}
	// handleCancel () {
	// 	this.setState({
	// 		visible: false
	// 	})
	// }
    //跳到底部
    goBottom = () => {
        window.scrollTo(0, document.documentElement.scrollHeight-document.documentElement.clientHeight-320);
    };
	// testFunc (value, index) {
	// 	if (index === 0) {
	// 		return value.length > 3 ? true : false
	// 	}
	// 	if (index === 1) {
	// 		return value.length > 1 ? true : false
	// 	}
	// 	if (index === 2) {
	// 		return value.length === 11 ? true : false
	// 	}
	// 	if (index === 3) {
	// 		return value.indexOf('@') !== -1 ? true : false
	// 	}
	// }
	// changeUser (e) {
	// 	this.setState({
	// 		isChecked: e.target.checked
	// 	})
	// }
	changeImg (current) {
		this.setState({
			imgCurrent: current
		})
	}
	iconChangeImg (current) {
		this.carouselRef.goTo(current, true)
	}
    //走马灯
    onImgChange = (index) => {
        this.setState({
            ...this.state,
            pickIcon: index
        })
    };
    handleIconClick = (index) => {
        this.setState({
            ...this.state,
            pickIcon: index
        }, () => {
            this.slider && this.slider.innerSlider.slickGoTo(this.state.pickIcon);
        })
    };
	submitContet () {
        let {name, mobile, email, company_name, showInput, warn3, warn4 } = this.state;
        if (showInput === false) {
            if (name.trim() !== "" && mobile.trim() !== "" && company_name.trim() !== "" && warn3 !== "手机号格式错误" && warn4!=="邮箱格式错误") {
		addApply({
            name: name,
            mobile: mobile,
            company_name: company_name,
            email: email,
			type: 1
		}).then(res => {
			if (res.code === 20000) {
				this.setState({
					modalTitle: '预约成功！',
					btnText: '我知道了',
					modalContnet: '我们的广告顾问将在两个工作日内与您电话联系，请您保持电话畅通'
				}, () => {
					this.setState({
						visible: true
					})
				})
			} else {
				this.setState({
					modalTitle: res.message,
					btnText: '取消',
					modalContnet: ''
				}, () => {
					this.setState({
						visible: true
					})
				})
			}
		})
            } else {
                if(company_name.trim() === "") {
                    this.setState({
                        warn1: '公司名称不能为空'
                    })
                } else if(name.trim() === "") {
                    this.setState({
                        warn2: '姓名不能为空'
                    })
                    }else if(mobile.trim() === "") {
                        this.setState({
                            warn3: '手机号不能为空'
                        })
                }
            }
        }else {
            if (name.trim() !== "" && mobile.trim() !== "" && warn3 !== "手机号格式错误" && warn4!=="邮箱格式错误") {
                addApply({
                    name: name,
                    mobile: mobile,
                    email: email,
                    type: 1
                }).then(res => {
                    if (res.code === 20000) {
                        this.setState({
                            modalTitle: '预约成功！',
                            btnText: '我知道了',
                            modalContnet: '我们的广告顾问将在两个工作日内与您电话联系，请您保持电话畅通'
                        }, () => {
                            this.setState({
                                visible: true
                            })
                        })
                    } else {
                        this.setState({
                            modalTitle: res.message,
                            btnText: '取消',
                            modalContnet: ''
                        }, () => {
                            this.setState({
                                visible: true
                            })
                        })
                    }
                })
            } else {
                if(name.trim() === "" ) {
                    this.setState({
                        warn2: '姓名不能为空',
                    })
                } else if (mobile.trim() === "") {
                    this.setState({
                        warn3: '手机号不能为空'
                    })
                }
            }
        }
	}
	// subData (e) {
	// 	let newData = this.state.form
	// 	newData[e.target.name] = e.target.value
	// 	this.setState({
	// 		form: newData
	// 	})
	// }
	// inputOnBlur (e, index) {
	// 	if (e.target.value === '' && index !== 0) {
	// 		let newForms = this.state.forms
	// 		newForms[index] = { errorType: true, errorMessage: '必填内容不能为空'}
	// 		this.setState({
	// 			forms: newForms
	// 		})
	// 	} else {
	// 		let newData = this.state.form
	// 		newData[e.target.name] = e.target.value
	// 		this.setState({
	// 			form: newData
	// 		})
	// 		if (e.target.value !== '') {
	// 			let newForms = this.state.forms
	// 			if (this.testFunc(e.target.value, index)) {
	// 				newForms[index] = { errorType: false, errorMessage: '', testError: newForms[index].testError }
	// 				this.setState({
	// 					forms: newForms
	// 				})
	// 			} else {
	// 				newForms[index] = { errorType: true, errorMessage: newForms[index].testError, testError: newForms[index].testError}
	// 				this.setState({
	// 					forms: newForms
	// 				})
	// 			}
	// 		}
	// 	}
	// }
    //顾问咨询表单
    onChangeValue = (e,type) => {
        let {mobile, email} = this.state;
        switch (type) {
            case 'company_name':
                this.setState({
                    company_name:e.target.value.trim()
                });
                if (e.target.value === '') {
                    this.setState({
                        warn1: '公司名称不能为空'
                    })
                }else {
                    this.setState({
                        warn1: ''
                    })
                }
                break;
            case 'checkbox':
                this.setState({ showInput: e.target.checked });
                if (e.target.checked === true) {
                    this.setState({ warn1: '' })
                }
                break;
            case 'name':
                this.setState({
                    name:e.target.value.trim()
                });
                if (e.target.value === '') {
                    this.setState({
                        warn2: '姓名不能为空'
                    })
                } else {
                    this.setState({
                        warn2: ''
                    })
                }
                break;
            case 'mobile':
                let mobileReg = new RegExp("^1[34578]\\d{9}$");
                this.setState({
                    mobile:e.target.value.trim()
                });
                if (e.target.value === '') {
                    this.setState({
                        warn3: '手机号不能为空'
                    })
                } else if (!mobileReg.test(mobile)) {
                    this.setState({
                        warn3: '手机号格式错误'
                    });
                } else {
                    this.setState({
                        warn3: ''
                    })
                }
                break;
            case 'email':
                let emailReg = new RegExp("^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$");
                this.setState({
                    email:e.target.value.trim()
                });
                if (email !== '' && !emailReg.test(email)) {
                    this.setState({
                        warn4: '邮箱格式错误'
                    });
                } else {
                    this.setState({
                        warn4: ''
                    })
                }
                break;
        }
        this.setState({ userName: e.target.value });
    };
	componentDidMount () {
		getBanner({
			type: 1
		}).then(res => {
			this.setState({
				imgList: res.data.list
			})
		})
	}
	render() {
        let { company_name, showInput, name, mobile, email, warn1, warn2, warn3, warn4, pickIcon} = this.state;
        let { onChangeValue, handleIconClick, onImgChange } = this;
		return(
			<div className="indexHome">
					<Carousel autoplay className="banner-carousel">
						{
							this.state.imgList.map((item, index) => {
								return (
									<div className='11' key={index}>
										<div className='banner' style={{backgroundImage: 'url(' + item.image + ')'}}>
										</div>
									</div>
								)
							})
						}
					</Carousel>
				{/* <div className='home-module home-contain ziyuan' style={{paddingBottom: '50px'}}>
					<div className='pull-left'>
						<img src={`${process.env.PUBLIC_URL}/images/mixin.jpg`} />
					</div>
					<div className="right-group pull-right">
						<div className="right-group--title text-center">
							全网络流量资源
						</div>
						<div className='text-center mt22'>QUANWANGLUOLIULIANGZIYUAN</div>
						<div className='mt22 lh24'>每天有超过十亿用户使用360、微博、爱奇艺等众多互联网产品，他们 搜索想要了解的知识，分享自己感兴趣的内容，浏览商业信息。 我们帮助您与这些受众建立联系，将优质商业信息推送给真正需要的人。</div>
						<div className='text-center'>
							<div className='sub-btn' onClick={this.goBottom}>立即咨询</div>
						</div>
					</div>
				</div> */}
				<div className='home-module home-contain ziyuan' style={{paddingTop: '81px'}}>
					<div className="right-group pull-left" style={{marginTop: '111px'}}>
						<div className="right-group--title text-center">
						全场景流量资源
						</div>
						<div className='text-center mt22'>搜索场景</div>
						<div className='mt22 lh24'>覆盖95%的网民,通过关键词，创意标题图片帮您锁定目标用户，无点击不收费。</div>
					</div>
					<div className='left-group pull-right'>
						<img src={`${process.env.PUBLIC_URL}/images/sousuo.png`} />
					</div>
				</div>
				<div className='home-module ziyuan sale' style={{paddingBottom: '50px'}}>
					<div className='home-contain'>
					<div className='pull-left'>
						<img src={`${process.env.PUBLIC_URL}/images/xinmeiti.png`} />
					</div>
					<div className="right-group pull-right" style={{marginTop: '111px'}}>
						<div className="right-group--title text-center">
						全场景流量资源
						</div>
						<div className='text-center mt22'>社交场景</div>
						<div className='mt22 lh24'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;多创意展现形式，快速传递品牌信息给用户，轻松带来海量曝光。</div>
					</div>
					</div>
				</div>
				<div className='home-module home-contain ziyuan' style={{paddingTop: '81px'}}>
					<div className="right-group pull-left" style={{marginTop: '111px'}}>
						<div className="right-group--title text-center">
						全场景流量资源
						</div>
						<div className='text-center mt22'>购物场景</div>
						<div className='mt22 lh24'>根据不同企业主自身特点，从娱乐、资讯、 社交等多领域提供“娱乐全触点营销”式的网络推广整体解决方案。</div>
					</div>
					<div className='left-group pull-right'>
						<img src={`${process.env.PUBLIC_URL}/images/gouwu.png`} />
					</div>
				</div>
                {/* <div className="module2">
                    <div className="content">
                        <p>全类型广告形式</p>
                        <p>QUANLEIXINGGUANGGAOXINGSHI</p>
                        <p>搜索广告、图文广告、信息流广告、视频广告、互动广告等全类型广告形式全面覆盖互联网用户人群，给广告主提供最优选择。 </p>
                        <div className="carousel">
                            <i className={`glyphicon glyphicon-search ${pickIcon !== 0 ? `icon` : 'icon pick-icon'}`} onClick={(e) => handleIconClick(0)}></i>
                            <i className={`glyphicon glyphicon-tianchong ${pickIcon !== 1 ? `icon` : 'icon pick-icon'}`} onClick={(e) => handleIconClick(1)}></i>
                            <i className={`glyphicon glyphicon-tuwen ${pickIcon !== 2 ? `icon` : 'icon pick-icon'}`} onClick={(e) => handleIconClick(2)}></i>
                            <i className={`glyphicon glyphicon-shiping ${pickIcon !== 3 ? `icon` : 'icon pick-icon'}`} onClick={(e) => handleIconClick(3)}></i>
                            <i className={`glyphicon glyphicon-hudong ${pickIcon !== 4 ? `icon` : 'icon pick-icon'}`} onClick={(e) => handleIconClick(4)}></i>
                            <Carousel
                                afterChange={onImgChange}
                                ref = { ref => this.slider = ref}
								// goTo={onPickIcon(3)}
                            >
                                <div>
                                    <img src={`${process.env.PUBLIC_URL}/images/索搜广告.png`} onClick={()=>{}} alt=""/>
                                </div>
                                <div>
                                    <img src={`${process.env.PUBLIC_URL}/images/信息流广告.png`} alt=""/>
                                </div>
                                <div>
                                    <img src={`${process.env.PUBLIC_URL}/images/图文广告.png`} alt=""/>
                                </div>
                                <div>
                                    <img src={`${process.env.PUBLIC_URL}/images/视频广告.png`} alt=""/>
                                </div>
                                <div>
                                    <img src={`${process.env.PUBLIC_URL}/images/互动广告.png`} alt=""/>
                                </div>
                            </Carousel>
                        </div>
                    </div>
                </div> */}
				{/*<div className='home-module banner-type' style={{padding: 0}}>*/}
					{/*<div className="gray-center" style={{paddingBottom: 100}}>*/}
					{/*<div className='home-contain'>*/}
						{/*<div className='my-title'>*/}
							{/*全类型广告形式*/}
						{/*</div>*/}
						{/*<div className='text-center mt22'>*/}
							{/*QUANLEIXINGGUANGGAOXINGSHI*/}
						{/*</div>*/}
						{/*<div className='text-center mt22'>搜索广告、图文广告、信息流广告、视频广告、互动广告等全类型广告形式全面覆盖互联网用户人群，给广告主提供最优选择。 </div>*/}
						{/*<div className='img-group'>*/}
							{/*<i className={`glyphicon glyphicon-search icon-1 ${this.state.imgCurrent === 0 ? 'i-active' : ''}`} onClick={this.iconChangeImg.bind(this, 0)}></i>*/}
							{/*<i className={`glyphicon glyphicon-tianchong icon-2 ${this.state.imgCurrent === 1 ? 'i-active' : ''}`} onClick={this.iconChangeImg.bind(this, 1)}></i>*/}
							{/*<i className={`glyphicon glyphicon-tuwen icon-3 ${this.state.imgCurrent === 2 ? 'i-active' : ''}`} onClick={this.iconChangeImg.bind(this, 2)}></i>*/}
							{/*<i className={`glyphicon glyphicon-shiping icon-4 ${this.state.imgCurrent === 3 ? 'i-active' : ''}`} onClick={this.iconChangeImg.bind(this, 3)}></i>*/}
							{/*<i className={`glyphicon glyphicon-hudong icon-5 ${this.state.imgCurrent === 4 ? 'i-active' : ''}`} onClick={this.iconChangeImg.bind(this, 4)}></i>*/}
							{/*<Carousel ref={this.setCarouselRef} afterChange={this.changeImg.bind(this)}>*/}
								{/*<img src={`${process.env.PUBLIC_URL}/images/索搜广告.png`} />*/}
								{/*<img src={`${process.env.PUBLIC_URL}/images/信息流广告.png`} />*/}
								{/*<img src={`${process.env.PUBLIC_URL}/images/图文广告.png`} />*/}
								{/*<img src={`${process.env.PUBLIC_URL}/images/视频广告.png`} />*/}
								{/*<img src={`${process.env.PUBLIC_URL}/images/互动广告.png`} />*/}
							{/*</Carousel>*/}
						{/*</div>*/}
					{/*</div>*/}
                    {/*</div>*/}
				{/*</div>*/}
				{/* <div className='home-module home-contain ziyuan' style={{paddingTop: '81px'}}>
					<div className="right-group pull-left" style={{marginTop: '111px'}}>
						<div className="right-group--title text-center">
							全场景流量布局
						</div>
						<div className='text-center mt22'>QUANCHANGJINGLIULIANGBUJU</div>
						<div className='mt22 lh24'>媒体流量涉及到社交、搜索、购物、浏览、资讯、工具、应用下载等场 景，全场景布局覆盖，拓展广告主全面营销范围，与用户建立良性的友好关系。</div>
					</div>
					<div className='left-group pull-right'>
						<img src={`${process.env.PUBLIC_URL}/images/单色.png`} />
                        <div className="xian" />
                        <div className="sphere sphere1" />
                        <div className="sphere sphere2" />
                        <div className="sphere sphere3" src={require("../../images/icon-7.png")} alt=""/>
                        <div className="sphere sphere4" />
                        <div className="sphere sphere5" src={require("../../images/icon-9.png")} alt=""/>
                        <div className="sphere sphere6" src={require("../../images/icon-10.png")} alt=""/>
                        <div className="sphere sphere7" src={require("../../images/icon-11.png")} alt=""/>
                        <div className="sphere sphere8" src={require("../../images/icon-12.png")} alt=""/>
                        <div className="sphere sphere9" src={require("../../images/icon-13.png")} alt=""/>
                        <div className="sphere sphere10" src={require("../../images/icon-14.png")} alt=""/>
					</div>

				</div> */}
				<div className='home-module sale' style={{padding: 0}}>
					<div className="gray-center">
					<div className='home-contain'>
						<div className='my-title'>
							多种营销模式
						</div>
						<div className='content-list'>
							{
								this.state.sale.map((item, i) => {
									return (
										<div className='content-one' key={i}>
											<i className={`glyphicon glyphicon-${item.icon}`}></i>
											<div className='content-title'>{item.title}</div>
											<div className='content-line'>
												{
													item.text.map((text, index) => {
														return (
															<div className="ccontent-one--line" key={index}>{text}</div>
														)
													})
												}
											</div>
										</div>
									)
								})
							}
						</div>
					</div>
                    </div>
				</div>
				<div className='home-module fuwu home-contain'>
					<div className='my-title'>
						本地专业化服务
					</div>
					<div className='content-list'>
						{
							this.state.locals.map((item, i) => {
								return (
									<div className='content-one' key={i}>
										<i className={`glyphicon glyphicon-${item.icon}`}></i>
										<div className='content-title'>{item.title}</div>
										<div className='content-line'>
											{
												item.text.map((text, index) => {
													return (
														<div className="ccontent-one--line" key={index}>{text}</div>
													)
												})
											}
										</div>
									</div>
								)
							})
						}
					</div>
				</div>
                <div className="module6">
                    <div className="content">
                        <div className="right">
                            <p>请广告顾问来电为您介绍</p>
                            <p>留下您的联系方式，我们的广告顾问将与您联系，免费咨询</p>
                            <Input
                                placeholder="企业名称 （必填）"
                                disabled={showInput}
                                prefix={<i className='glyphicon glyphicon-qiye'></i>}
                                value={company_name}
                                onBlur={(e)=>{onChangeValue(e,'company_name')}}
                                onChange={(e)=>{onChangeValue(e,'company_name')}}
								// style={{ marginBottom: '14px' }}
                            />
                            <div className="warn">{warn1}</div>
                            <Checkbox onChange={(e)=>{onChangeValue(e,'checkbox')}} style={{ marginBottom: '14px', marginLeft: '5px', fontSize: '12px' }}>我是个人广告主</Checkbox>
                            <Input
                                placeholder="姓名 （必填）"
                                prefix={<i className='glyphicon glyphicon-user'></i>}
                                value={name}
                                onBlur={(e)=>{onChangeValue(e,'name')}}
                                onChange={(e)=>{onChangeValue(e,'name')}}
                            />
                            <div className="warn">{warn2}</div>
                            <Input
                                placeholder="手机 （必填）"
                                prefix={<i className='glyphicon glyphicon-mobile'></i>}
                                value={mobile}
                                onBlur={(e)=>{onChangeValue(e,'mobile')}}
                                onChange={(e)=>{onChangeValue(e,'mobile')}}
                            />
                            <div className="warn">{warn3}</div>
                            <Input
                                placeholder="邮箱"
                                prefix={<i className='glyphicon glyphicon-mail'></i>}
                                value={email}
                                onBlur={(e)=>{onChangeValue(e,'email')}}
                                onChange={(e)=>{onChangeValue(e,'email')}}
                            />
                            <div className="warn">{warn4}</div>
                            <div className='submit-btn' onClick={this.submitContet.bind(this)}>
                            预约顾问咨询
                            </div>
                        </div>
                        <div className="left">
                            <p>新客户咨询专线</p>
                            <p>通过以下方式联系我们的广告专家，了解更多服务及产品信息</p>
                            <i className='glyphicon glyphicon-tele'></i>
                            <p className="telephone">400-166-7171</p>
                            <p>我们的工作时间是周一至周五 9:00-18:00</p>
                        </div>
                    </div>
                </div>
				{/*<div className="home-module submit">*/}
					{/*<div className="home-contain form-submit" id='form'>*/}
						{/*<div className='form-left pull-left'>*/}
							{/*<div className="form-title text-center">请广告顾问来电为您介绍</div>*/}
							{/*<div className='mt22'>通过以下方式联系我们的广告专家，了解更多服务及产品信息</div>*/}
							{/*<div style={{marginBottom: '40px'}} className={`input-group ${this.state.forms[0].errorType ? 'error' : ''}`} onBlur={(e) => this.inputOnBlur(e, 0)}>*/}
								{/*<input type="text" name='company-name' placeholder='企业名称 （必填）' disabled={this.state.isChecked ? "disabled" : ""}/>*/}
								{/*<i className='glyphicon glyphicon-qiye'></i>*/}
								{/*<div className='error-message'>{this.state.forms[0].errorMessage}</div>*/}
								{/*<Checkbox className='checkbox' onChange={this.changeUser.bind(this)}> 我是个人广告主</Checkbox>*/}
							{/*</div>*/}
							{/*<div className={`input-group ${this.state.forms[1].errorType ? 'error' : ''}`} onBlur={(e) => this.inputOnBlur(e, 1)}>*/}
								{/*<input type="text" name='name' placeholder='姓名 （必填）' />*/}
								{/*<i className='glyphicon glyphicon-user'></i>*/}
								{/*<div className='error-message'>{this.state.forms[1].errorMessage}</div>*/}
							{/*</div>*/}
							{/*<div className={`input-group ${this.state.forms[2].errorType ? 'error' : ''}`} onBlur={(e) => this.inputOnBlur(e, 2)}>*/}
								{/*<input type="text" name='mobile' placeholder='手机 （必填）' />*/}
								{/*<i className='glyphicon glyphicon-mobile'></i>*/}
								{/*<div className='error-message'>{this.state.forms[2].errorMessage}</div>*/}
							{/*</div>*/}
							{/*<div className={`input-group ${this.state.forms[3].errorType ? 'error' : ''}`} onBlur={(e) => this.inputOnBlur(e, 3)}>*/}
								{/*<input type="text" name='email' placeholder='邮箱' onBlur={(e) => this.subData(e)}/>*/}
								{/*<i className='glyphicon glyphicon-mail'></i>*/}
									{/*<div className='error-message'>{this.state.forms[3].errorMessage}</div>*/}
							{/*</div>*/}
							{/*<div className='text-center'>*/}
								{/*<div className='submit-btn' onClick={this.submitContet.bind(this)}>*/}
									{/*预约顾问咨询*/}
								{/*</div>*/}
							{/*</div>*/}
						{/*</div>*/}
						{/*<div className='form-right pull-right text-center'>*/}
							{/*<div className="form-title text-center">新客户咨询专线</div>*/}
							{/*<div className='mt22'>通过以下方式联系我们的广告专家，了解更多服务及产品信息</div>*/}
							{/*<i className='glyphicon glyphicon-tele'></i>*/}
							{/*<div className='phone-number'>400-166-7171</div>*/}
							{/*<div className='my-time'>我们的工作时间是周一至周五 9:00-18:00</div>*/}
						{/*</div>*/}
					{/*</div>*/}
				{/*</div>*/}
				<Modal
					closable={false}
					width='610px'
					className={this.state.btnText === '我知道了' ? 'btn-success' : 'btn-error'}
					title={this.state.modalTitle}
					visible={this.state.visible}
					onOk={this.handleOk.bind(this)}
					okText={this.state.btnText}
                    cancelText={'取消'}
				>
					{this.state.modalContnet}
					</Modal>
			</div>
		)
	}
}
export default Home;



// WEBPACK FOOTER //
// ./src/components/Index/home.jsx